module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/ClanQuestsTutorial/images/slide-4-image.45fb7d4f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/ClanQuestsTutorial/images/slide-4-image.png
// module id = 2936
// module chunks = 11